<button type="submit" class="button _primary"
        [class.expanded]="expanded"
        [disabled]="disabled || loading">
    <a-button-text [labelKey]="labelKey" [loading]="loading"></a-button-text>
</button>
